export const ActionValoration = {
  LOAD_HOME_VALORATION: '[Home Valoration] Load State Home Valoration',
  LOAD_PRAGMAPOWERS_CATEGORIES:
    '[Valoration Page] Cargar los Team PragmaPowers',
  LOAD_PRAGMAPOWERS_CATEGORIES_SUCCESSFULLY:
    '[Valoration Page] Cargar los Team PragmaPowers exitosamente',
  LOAD_PRAGMAPOWER_DEFINITION:
    '[Valoration Page] Carga las Definición de un Team PragmaPower',
  LOAD_PRAGMAPOWER_DEFINITION_SUCCESSFULLY:
    '[Valoration Page] Carga la definición de un Team PragmaPower exitosamente',
  LOAD_PRAGMAPOWER_SCORES:
    '[Valoration Page] Carga los Scores de un Team PragmaPower',
  LOAD_PRAGMAPOWER_SCORES_SUCCESSFULLY:
    '[Valoration Page] Carga los scores de un Team PragmaPower exitosamente',
  SAVE_ASSESSMENT_SUMMARY:
    '[Assessment Summary] Guardar el resumen de la valoración',
  SAVE_ASSESSMENT_STAGES:
    '[Assessment Stages] Guardar los estados de la valoración',
  LOAD_CURRENT_VALORATION:
    '[Current Assessment] Cargar la valoración actual',
  LOAD_LAST_VALORATION:
    '[Last Valoration] Cargar la ultima valoración',
  LOAD_LAST_VALORATION_SUCCESSFULLY:
    '[Last Valoration] Ultima valoración cargada exitosamente',
  LOAD_APPROVED_ASSESSMENT:
    '[Approved Assessment] Cargar la valoración aprobada',
  LOAD_APPROVED_ASSESSMENT_SUCCESSFULLY:
    '[Approved Assessment] Cargar la valoración aprobada exitosamente',
  LOAD_PENDING_ASSESSMENT:
    '[Pending Assessment] Cargar la valoración pendiente',
  LOAD_PENDING_ASSESSMENT_SUCCESSFULLY:
    '[Pending Assessment] Cargar la valoración pendiente exitosamente',
  LOAD_REJECTED_ASSESSMENT:
    '[Rejected Assessment] Cargar la valoración rechazada',
  LOAD_REJECTED_ASSESSMENT_SUCCESSFULLY:
    '[Rejected Assessment] Cargar la valoración rechazada exitosamente',
  LOAD_STARTED_ASSESSMENT: '[Started Assessment] Cargar la valoración iniciada',
  LOAD_STARTED_ASSESSMENT_SUCCESSFULLY:
    '[Started Assessment] Cargar la valoración iniciada exitosamente',
  LOAD_FINALIZED_AUTOASSESSMENT:
    '[Finalized Auto Assessment] Cargar la valoración finalizada',
  LOAD_FINALIZED_AUTOASSESSMENT_SUCCESSFULLY:
    '[Finalized Auto Assessment] Cargar la valoración finalizada exitosamente',
  LOAD_STARTED_AUTOASSESSMENT:
    '[Started Auto Assessment] Cargar la valoración iniciada',
  LOAD_STARTED_AUTOASSESSMENT_SUCCESSFULLY:
    '[Started Auto Assessment] Cargar la valoración iniciada exitosamente',
  SET_SENIORITY_CURRENT_VALORATION:
    '[Current Valoration] Actualizar la data de la valoración actual',
  RESET_FINALIZED_ASSESSMENT: '[Assessment] Reiniciar Finalizado',
  RESET_APPROVED_ASSESSMENT: '[Assessment] Reiniciar Aprobado',
  RESET_REJECTED_ASSESSMENT: '[Assessment] Reiniciar Rechazado',

  RESET_STARTED_ASSESSMENT: '[Assessment] Reiniciar Iniciado',
  RESET_PENDING_ASSESSMENT: '[Assessment] Reiniciar Pendiente',
  RESET_FINALIZED_AUTOASSESSMENT:
    '[Assessment] Reiniciar Autoevaluación Finalizado',
  RESET_STARTED_AUTOASSESSMENT:
    '[Assessment] Reiniciar Autoevaluación Iniciado',
  RESET_VALORATION_STATE:
    '[Valoration Page] Resetea todo el estado de Valoración',
};
